import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import CCService from "../../services/httpServiceWithoutSuperAdmin";

const schema = yup.object().shape({
  title: yup.string().required("Title is required"),
  short_description: yup.string().max(250, "Max 250 characters"),
  full_description: yup.string(),
  banner_url: yup
    .string()
    .url("Must be a valid URL")
    .required("Banner required"),
  status: yup.string().oneOf(["draft", "published", "archived"]),
});

export default function AheadEventForm({ onSuccess, initialData }) {
  const services = new CCService();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: initialData || {
      title: "",
      short_description: "",
      full_description: "",
      banner_url: "",
      status: "draft",
    },
    resolver: yupResolver(schema),
  });

  const onSubmit = async (data) => {
    try {
      console.log("data", data, initialData);
      if (initialData?.id) {
        // await adminApi.updateEvent(initialData.id, data);
        const response = await services.put(
          `/ahead/event-types/${initialData.id}`,
          data
        );
        onSuccess?.({
          id: response?.data?.data?.id,
          ...data,
        });
      } else {
        const payload = {
          ...data,
        };
        const response = await services.post("/ahead/event-types", payload);
        onSuccess?.({
          id: response?.data?.data?.id,
          ...data,
        });
      }
    } catch (err) {
      console.error(err);
      alert("Failed to save event");
    }
  };

  // Inline styles
  const formStyle = {
    display: "block",
    // width: 500,
    // maxWidth: "95vw",
    boxSizing: "border-box",
    padding: 16,
    borderRadius: 10,
    background: "#ffffff",
    fontFamily:
      "Inter, Roboto, system-ui, -apple-system, 'Segoe UI', 'Helvetica Neue', Arial",
  };
  const headingStyle = { fontSize: 18, fontWeight: 600, margin: "0 0 12px 0" };
  const fieldWrap = { marginBottom: 12 };
  const labelStyle = {
    display: "block",
    fontSize: 13,
    fontWeight: 600,
    marginBottom: 6,
  };
  const inputStyle = {
    width: "100%",
    padding: "10px 12px",
    fontSize: 14,
    borderRadius: 8,
    border: "1px solid #E5E7EB", // slate-200
    boxSizing: "border-box",
    outline: "none",
  };
  const textareaStyle = { ...inputStyle, minHeight: 80, resize: "vertical" };
  const selectStyle = { ...inputStyle, height: 40 };
  const errorStyle = { color: "#DC2626", marginTop: 6, fontSize: 13 }; // red-600
  const submitBtn = {
    width: "100%",
    padding: "10px 14px",
    borderRadius: 8,
    border: "none",
    fontWeight: 700,
    fontSize: 14,
    cursor: isSubmitting ? "not-allowed" : "pointer",
    backgroundColor: isSubmitting ? "#A78BFA" : "#4F46E5", // lighter when disabled
    color: "#fff",
    opacity: isSubmitting ? 0.85 : 1,
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} style={formStyle}>
      <h2 style={headingStyle}>Event Details</h2>

      <div style={fieldWrap}>
        <label style={labelStyle}>Title</label>
        <input {...register("title")} style={inputStyle} />
        {errors.title && <p style={errorStyle}>{errors.title.message}</p>}
      </div>

      <div style={fieldWrap}>
        <label style={labelStyle}>Short Description</label>
        <textarea
          {...register("short_description")}
          rows={2}
          style={textareaStyle}
        />
        {errors.short_description && (
          <p style={errorStyle}>{errors.short_description.message}</p>
        )}
      </div>

      <div style={fieldWrap}>
        <label style={labelStyle}>Full Description</label>
        <textarea
          {...register("full_description")}
          rows={4}
          style={textareaStyle}
        />
      </div>

      <div style={fieldWrap}>
        <label style={labelStyle}>Banner URL</label>
        <input {...register("banner_url")} style={inputStyle} />
        {errors.banner_url && (
          <p style={errorStyle}>{errors.banner_url.message}</p>
        )}
      </div>

      <div style={fieldWrap}>
        <label style={labelStyle}>Status</label>
        <select {...register("status")} style={selectStyle}>
          <option value="draft">Draft</option>
          <option value="published">Published</option>
          <option value="archived">Archived</option>
        </select>
      </div>

      <button type="submit" disabled={isSubmitting} style={submitBtn}>
        {isSubmitting ? "Saving..." : "Save Event"}
      </button>
    </form>
  );
}
